import configs from 'configs';
import {
  SIGN_IN,
  SIGN_UP,
  SIGN_OUT,
  SET_USER_AVATAR,
  UPDATE_USER_INFO,
} from 'constants/actionTypes';
import Fetch from 'helpers/fetch';

const { hierarchyId } = configs;

export const signIn = (username, password, rememberMe) => async () => {
  const { result } = await Fetch.POST(`/matchPoker/authenticate`, {
    action: SIGN_IN,
    body: {
      password,
      username,
      hierarchyId,
    },
  });

  if (rememberMe && result) {
    window.localStorage.setItem('mpToken', result.token);
  }

  return result;
};

export const autoSignIn = token => async () => {
  const { result, error } = await Fetch.POST(`/matchPoker/authenticate`, {
    action: SIGN_IN,
    body: {
      token,
    },
  });

  if (result) {
    window.localStorage.setItem('mpToken', result.token);
  }

  if (error) {
    window.localStorage.removeItem('mpToken');
  }

  return result;
};

export const signUp = userDetails => async () => {
  const { result } = await Fetch.POST(`/matchPoker/register`, {
    action: SIGN_UP,
    body: {
      ...userDetails,
      hierarchyId,
    },
  });
  if (result) {
    window.localStorage.setItem('mpToken', result.token);
  }

  return result;
};

export const updateUserInfo = userInfo => async (dispatch, getState) => {
  const { auth } = getState();
  const { result } = await Fetch.POST(`/matchPoker/updateUserInfo`, {
    action: UPDATE_USER_INFO,
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    body: userInfo,
  });

  if (window.localStorage.getItem('mpToken') && result) {
    window.localStorage.setItem('mpToken', result.token);
  }

  return result;
};

export const signOut = () => ({
  type: SIGN_OUT,
});

export const setUserAvatar = payload => ({
  type: SET_USER_AVATAR,
  payload,
});
